import {
  RevitPluginPage,
  RevitPluginVersionCreateForm,
} from '@components-common/support';
import { layoutWorkspace } from '../../../_website/_common/layout.workspace';
import { PageFormToolbar } from '../../../components-common/layout/views/PageFormToolbar';
import { getGenericMediaSchema } from '../../../components-common/support/schema';

/**
 * Configuration Section: revitPluginSection
 *
 * This configuration section defines the structure and layout for the "Revit Plugin" area in the application. It includes screens
 * for viewing and creating new versions of the Revit Plugin, utilizing a workspace layout. The section is accessible to users, 
 * with the 'Create New Version' screen specifically restricted to 'STUDY_DIRECTOR'.
 *
 * Properties:
 * @type {ConfigSection}
 * @property {string} id - The unique identifier for the section ('revit-plugin').
 * @property {string} path - The base path for the section ('revit-plugin').
 * @property {string} title - The title displayed for the section ('Revit plugin').
 * @property {React.ComponentType} layout - The layout component used for this section (`layoutWorkspace`).
 * @property {Array} screens - List of screens included in this section.
 */
export const revitPluginSection = {
  id: 'revit-plugin',
  path: 'revit-plugin',
  title: 'Revit plugin',
  layout: layoutWorkspace,
  screens: [
    {
      id: 'index',
      path: '',
      tmp: 'index',
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      Component: RevitPluginPage,
    },
    {
      id: 'create',
      title: 'Create New Version',
      path: 'new',
      tmp: 'create',
      roles: ['STUDY_DIRECTOR'],
      left: ['create'],
      Component: PageFormToolbar,
      form: RevitPluginVersionCreateForm,
      empty: {
        name: '',
        description: '',
      },
      schema: getGenericMediaSchema(),
    },
  ],
};
